import React, { useState } from 'react';

type CabTimeSlotPickProps = {
  closeTravelForPopup: () => void;
  handleTimeSlot: (time: string, mer: string) => void;
  labelText?: string;
  selectedTime: string;
};

const CabTimeSlotPick = React.memo(
  ({
    selectedTime,
    closeTravelForPopup,
    handleTimeSlot,
    labelText
  }: CabTimeSlotPickProps) => {
    const timeSlots = [
      '12:00',
      '12:30',
      '01:00',
      '01:30',
      '02:00',
      '02:30',
      '03:00',
      '03:30',
      '04:00',
      '04:30',
      '05:00',
      '05:30',
      '06:00',
      '06:30',
      '07:00',
      '07:30',
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30'
    ];
    const meridian = ['AM', 'PM'];

    const renderSlots = () => {
      return meridian.map(meridian => {
        return timeSlots.map(name => {
          return (
            <li
              className={`truncate ${
                name + ' ' + meridian === selectedTime ? 'selected' : ''
              }`}
              key={name + ' ' + meridian}
              onClick={() => {
                handleTimeSlot(name, meridian);
              }}
            >
              <p className="font14 latoBold appendBottom2">
                {name} {meridian}
              </p>
            </li>
          );
        });
      });
    };
    return (
      <div className={`travelForPopup`}>
        <p className="travelForPopup--header">
          <span className="font18 latoBold blackText">
            {labelText ? labelText : 'Select Start Time'}
          </span>
          <span className="close" onClick={() => closeTravelForPopup()}></span>
        </p>
        <ul className="renderCabSlots">{renderSlots()}</ul>
      </div>
    );
  }
);

export default CabTimeSlotPick;
